import { useClient } from '@composables/use-clients';
import {
  GetRequestArgsType,
  PostRequestArgsType,
  DeleteRequestArgsType,
} from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type GetTeamRequiredSkillsAssigneesArgsType = GetRequestArgsType & {
  teamCode: string;
};

export type GetTeamRequiredSkillAssigneesArgsType = GetRequestArgsType & {
  teamCode: string;
  teamRequiredSkillId: number;
};

export type GetTeamRequiredSkillAssigneeDetailsArgsType = GetRequestArgsType & {
  teamCode: string;
  teamRequiredSkillId: number;
};

export type PostTeamRequiredSkillAssigneePayloadType = {
  teamTenantUserId: number;
};

export type PostTeamRequiredSkillAssigneeArgsType = (
  PostRequestArgsType<PostTeamRequiredSkillAssigneePayloadType> & {
    teamCode: string;
    teamRequiredSkillId: number;
  }
);

export type DeleteTeamRequiredSkillAssigneeArgsType = DeleteRequestArgsType & {
  teamCode: string;
  teamRequiredSkillId: number;
  teamRequiredSkillAssigneeId: number;
};

export const apiFetchTeamRequiredSkillsAssignees = async ({
  domain = useTenantStore().domain,
  teamCode,
  errorConfig = {},
  callbacks = {},
}: GetTeamRequiredSkillsAssigneesArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.TeamRequiredSkillsAssignees({ domain, teamCode }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiFetchTeamRequiredSkillAssignees = async ({
  domain = useTenantStore().domain,
  teamCode,
  teamRequiredSkillId,
  errorConfig = {},
  callbacks = {},
}: GetTeamRequiredSkillAssigneesArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.teamRequiredSkillAssignees({
        domain,
        teamCode,
        teamRequiredSkillId,
      }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiFetchTeamRequiredSkillAssigneeDetails = async ({
  domain = useTenantStore().domain,
  teamCode,
  teamRequiredSkillId,
  errorConfig = {},
  callbacks = {},
}: GetTeamRequiredSkillAssigneeDetailsArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.teamRequiredSkillAssigneeDetails({
        domain,
        teamCode,
        teamRequiredSkillId,
      }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiCreateTeamRequiredSkillAssignee = async ({
  domain = useTenantStore().domain,
  teamCode,
  teamRequiredSkillId,
  payload,
  errorConfig = {},
  callbacks = {},
}: PostTeamRequiredSkillAssigneeArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.teamRequiredSkillAssignees({
        domain,
        teamCode,
        teamRequiredSkillId,
      }),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiDeleteTeamRequiredSkillAssignee = async ({
  domain = useTenantStore().domain,
  teamCode,
  teamRequiredSkillId,
  teamRequiredSkillAssigneeId,
  errorConfig = {},
  callbacks = {},
}: DeleteTeamRequiredSkillAssigneeArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.delete({
      url: urls.v1.teamRequiredSkillAssignees({
        domain,
        teamCode,
        teamRequiredSkillId,
        teamRequiredSkillAssigneeId,
      }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
